// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.failed-idoc-page .filter-date-input {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  min-width: 160px;
  background: white;
  height: 38px;
  box-sizing: border-box;
}

.failed-idoc-page .batch-monitor-header .filter-section {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.failed-idoc-page .filter-section .filter-label {
  margin: 0;
}

.failed-idoc-page .filter-section .filter-date-input,
.failed-idoc-page .filter-section .filter-btn {
  height: 38px;
  box-sizing: border-box;
}

.failed-idoc-filters {
  margin-bottom: 12px;
  padding: 16px 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.failed-idoc-filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px 16px;
}

.failed-idoc-filter-group {
  min-width: 0;
}

.failed-idoc-filter-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.failed-idoc-filter-input {
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  box-sizing: border-box;
}

.failed-idoc-filter-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 1px #667eea;
}

.failed-idoc-select__control {
  min-height: 38px !important;
  border-radius: 6px !important;
}

.failed-idoc-select__value-container {
  padding: 2px 8px !important;
}

.failed-idoc-select__multi-value {
  background: #e0e7ff !important;
  border-radius: 4px !important;
}

.failed-idoc-select__multi-value__label {
  color: #3730a3 !important;
  font-size: 12px !important;
}

.failed-idoc-filters-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.failed-idoc-reset-btn {
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: white;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.failed-idoc-reset-btn:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.failed-idoc-reset-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.failed-idoc-table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.failed-idoc-table-toolbar .failed-idoc-pagination {
  flex: 1 1;
  min-width: 280px;
  margin-bottom: 0;
}

.failed-idoc-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.failed-idoc-selection-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  color: #4338ca;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.failed-idoc-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  padding: 12px 16px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.failed-idoc-pagination-info {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
}

.failed-idoc-pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.failed-idoc-pagination-pages {
  display: flex;
  align-items: center;
  gap: 4px;
}

.failed-idoc-pagination-btn {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: white;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.failed-idoc-pagination-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.failed-idoc-pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.failed-idoc-pagination-btn.active {
  background: #667eea;
  border-color: #667eea;
  color: white;
}

.failed-idoc-pagination-ellipsis {
  padding: 0 6px;
  color: #94a3b8;
  font-size: 13px;
}

.failed-idoc-retrigger-btn {
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(180deg, #667eea 0%, #5a67d8 100%);
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(90, 103, 216, 0.24);
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.failed-idoc-retrigger-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(90, 103, 216, 0.28);
  transform: translateY(-1px);
}

.failed-idoc-retrigger-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.job-monitor-table .row-failed {
  background: #fff5f5;
}

.job-monitor-table .row-failed:hover {
  background: #fed7d7;
}

.job-monitor-table .failed-idoc-row-selected {
  background: #eef2ff !important;
}

.job-monitor-table .failed-idoc-row-selected.row-failed {
  background: #fce7f3 !important;
}

.job-monitor-table .failed-idoc-row-selected:hover {
  background: #e0e7ff !important;
}

.failed-idoc-power-search-link {
  color: #2563eb;
  font-weight: 500;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  font-size: 13px;
  text-decoration: none;
}

.failed-idoc-power-search-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.failed-idoc-sortable-th {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.failed-idoc-sortable-th:hover {
  background: #f1f5f9;
}

.failed-idoc-th-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.failed-idoc-sort-indicator {
  color: #667eea;
  font-weight: 700;
}

/* First column — selection */
.failed-idoc-select-th,
.failed-idoc-select-cell {
  width: 52px;
  min-width: 52px;
  max-width: 52px;
  padding: 0 !important;
  text-align: center;
  vertical-align: middle;
  background: #fafbfc;
  border-right: 1px solid #edf2f7;
  position: sticky;
  left: 0;
  z-index: 2;
}

.failed-idoc-page .job-monitor-table thead .failed-idoc-select-th {
  background: #f8fafc;
  z-index: 3;
}

.failed-idoc-select-cell-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 44px;
  box-sizing: border-box;
}

.failed-idoc-checkbox-label {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.failed-idoc-row-checkbox {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.failed-idoc-checkbox-custom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  color: transparent;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease,
    color 0.15s ease;
}

.failed-idoc-checkbox-icon {
  width: 12px;
  height: 10px;
}

.failed-idoc-checkbox-label:hover .failed-idoc-checkbox-custom {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.12);
}

.failed-idoc-row-checkbox:focus-visible + .failed-idoc-checkbox-custom {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.failed-idoc-row-checkbox:checked + .failed-idoc-checkbox-custom {
  border-color: #667eea;
  background: #667eea;
  color: #fff;
  box-shadow: 0 1px 2px rgba(102, 126, 234, 0.35);
}

.failed-idoc-checkbox-custom--header {
  border-style: dashed;
  border-color: #cbd5e1;
  background: #fff;
  cursor: default;
  pointer-events: none;
}

.failed-idoc-select-empty {
  color: #cbd5e1;
  font-size: 13px;
}

.failed-idoc-action-th,
.failed-idoc-action-cell {
  white-space: nowrap;
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .failed-idoc-page .filter-date-input,
[data-theme="dark"] .failed-idoc-filter-input,
[data-theme="dark"] .failed-idoc-reset-btn,
[data-theme="dark"] .failed-idoc-pagination-btn {
  background: var(--surface);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .failed-idoc-filters,
[data-theme="dark"] .failed-idoc-pagination {
  background: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .failed-idoc-filter-label,
[data-theme="dark"] .failed-idoc-pagination-info {
  color: var(--text-muted);
}
[data-theme="dark"] .failed-idoc-reset-btn:hover:not(:disabled),
[data-theme="dark"] .failed-idoc-pagination-btn:hover:not(:disabled),
[data-theme="dark"] .failed-idoc-sortable-th:hover {
  background: var(--surface-hover);
  border-color: var(--border-strong);
}
[data-theme="dark"] .job-monitor-table .row-failed {
  background: rgba(220, 38, 38, 0.14);
}
[data-theme="dark"] .job-monitor-table .row-failed:hover {
  background: rgba(220, 38, 38, 0.24);
}
[data-theme="dark"] .job-monitor-table .failed-idoc-row-selected {
  background: rgba(102, 126, 234, 0.18) !important;
}
[data-theme="dark"] .failed-idoc-select-th,
[data-theme="dark"] .failed-idoc-select-cell,
[data-theme="dark"] .failed-idoc-page .job-monitor-table thead .failed-idoc-select-th {
  background: var(--surface-2);
  border-right-color: var(--border);
}
[data-theme="dark"] .failed-idoc-checkbox-custom {
  border-color: var(--border-strong);
  background: var(--surface);
}
[data-theme="dark"] .failed-idoc-checkbox-custom--header {
  background: var(--surface);
}

@media (max-width: 768px) {
  .failed-idoc-page .batch-monitor-header .filter-section {
    flex-wrap: wrap;
    width: 100%;
  }

  .failed-idoc-page .filter-date-input {
    min-width: 0;
    width: 100%;
  }

  .failed-idoc-page .filter-section .filter-btn {
    width: 100%;
  }

  .failed-idoc-filters {
    padding: 12px;
  }

  .failed-idoc-filters-grid {
    grid-template-columns: 1fr;
  }

  .failed-idoc-filters-actions {
    justify-content: stretch;
  }

  .failed-idoc-reset-btn {
    width: 100%;
  }

  .failed-idoc-table-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .failed-idoc-table-toolbar .failed-idoc-pagination {
    min-width: 0;
  }

  .failed-idoc-toolbar-actions {
    justify-content: stretch;
    flex-wrap: wrap;
  }

  .failed-idoc-retrigger-btn {
    width: 100%;
  }

  .failed-idoc-selection-pill {
    white-space: normal;
  }

  .failed-idoc-pagination {
    flex-direction: column;
    align-items: stretch;
  }

  .failed-idoc-pagination-controls {
    justify-content: center;
  }

  .failed-idoc-pagination-info {
    white-space: normal;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/failed-idoc-monitoring/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,2EAA2E;AAC7E;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;oBACkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;;;;EAIE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;;EAEE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;;EAGE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gDAAgD;AAClD;AACA;;;EAGE,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".failed-idoc-page .filter-date-input {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  min-width: 160px;\n  background: white;\n  height: 38px;\n  box-sizing: border-box;\n}\n\n.failed-idoc-page .batch-monitor-header .filter-section {\n  display: flex;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.failed-idoc-page .filter-section .filter-label {\n  margin: 0;\n}\n\n.failed-idoc-page .filter-section .filter-date-input,\n.failed-idoc-page .filter-section .filter-btn {\n  height: 38px;\n  box-sizing: border-box;\n}\n\n.failed-idoc-filters {\n  margin-bottom: 12px;\n  padding: 16px 18px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.failed-idoc-filters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 14px 16px;\n}\n\n.failed-idoc-filter-group {\n  min-width: 0;\n}\n\n.failed-idoc-filter-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.failed-idoc-filter-input {\n  width: 100%;\n  height: 38px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  box-sizing: border-box;\n}\n\n.failed-idoc-filter-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 1px #667eea;\n}\n\n.failed-idoc-select__control {\n  min-height: 38px !important;\n  border-radius: 6px !important;\n}\n\n.failed-idoc-select__value-container {\n  padding: 2px 8px !important;\n}\n\n.failed-idoc-select__multi-value {\n  background: #e0e7ff !important;\n  border-radius: 4px !important;\n}\n\n.failed-idoc-select__multi-value__label {\n  color: #3730a3 !important;\n  font-size: 12px !important;\n}\n\n.failed-idoc-filters-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n\n.failed-idoc-reset-btn {\n  padding: 8px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: white;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.failed-idoc-reset-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.failed-idoc-reset-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.failed-idoc-table-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.failed-idoc-table-toolbar .failed-idoc-pagination {\n  flex: 1;\n  min-width: 280px;\n  margin-bottom: 0;\n}\n\n.failed-idoc-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.failed-idoc-selection-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #eef2ff;\n  border: 1px solid #c7d2fe;\n  color: #4338ca;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n\n.failed-idoc-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 12px;\n  padding: 12px 16px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.failed-idoc-pagination-info {\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.failed-idoc-pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.failed-idoc-pagination-pages {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.failed-idoc-pagination-btn {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: white;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.failed-idoc-pagination-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.failed-idoc-pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.failed-idoc-pagination-btn.active {\n  background: #667eea;\n  border-color: #667eea;\n  color: white;\n}\n\n.failed-idoc-pagination-ellipsis {\n  padding: 0 6px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.failed-idoc-retrigger-btn {\n  padding: 10px 18px;\n  border: none;\n  border-radius: 8px;\n  background: linear-gradient(180deg, #667eea 0%, #5a67d8 100%);\n  color: white;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(90, 103, 216, 0.24);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n}\n\n.failed-idoc-retrigger-btn:hover:not(:disabled) {\n  box-shadow: 0 4px 12px rgba(90, 103, 216, 0.28);\n  transform: translateY(-1px);\n}\n\n.failed-idoc-retrigger-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.job-monitor-table .row-failed {\n  background: #fff5f5;\n}\n\n.job-monitor-table .row-failed:hover {\n  background: #fed7d7;\n}\n\n.job-monitor-table .failed-idoc-row-selected {\n  background: #eef2ff !important;\n}\n\n.job-monitor-table .failed-idoc-row-selected.row-failed {\n  background: #fce7f3 !important;\n}\n\n.job-monitor-table .failed-idoc-row-selected:hover {\n  background: #e0e7ff !important;\n}\n\n.failed-idoc-power-search-link {\n  color: #2563eb;\n  font-weight: 500;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  padding: 0;\n  font-size: 13px;\n  text-decoration: none;\n}\n\n.failed-idoc-power-search-link:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n}\n\n.failed-idoc-sortable-th {\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.failed-idoc-sortable-th:hover {\n  background: #f1f5f9;\n}\n\n.failed-idoc-th-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.failed-idoc-sort-indicator {\n  color: #667eea;\n  font-weight: 700;\n}\n\n/* First column — selection */\n.failed-idoc-select-th,\n.failed-idoc-select-cell {\n  width: 52px;\n  min-width: 52px;\n  max-width: 52px;\n  padding: 0 !important;\n  text-align: center;\n  vertical-align: middle;\n  background: #fafbfc;\n  border-right: 1px solid #edf2f7;\n  position: sticky;\n  left: 0;\n  z-index: 2;\n}\n\n.failed-idoc-page .job-monitor-table thead .failed-idoc-select-th {\n  background: #f8fafc;\n  z-index: 3;\n}\n\n.failed-idoc-select-cell-inner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 44px;\n  box-sizing: border-box;\n}\n\n.failed-idoc-checkbox-label {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.failed-idoc-row-checkbox {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.failed-idoc-checkbox-custom {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 6px;\n  background: #fff;\n  color: transparent;\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease,\n    color 0.15s ease;\n}\n\n.failed-idoc-checkbox-icon {\n  width: 12px;\n  height: 10px;\n}\n\n.failed-idoc-checkbox-label:hover .failed-idoc-checkbox-custom {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.12);\n}\n\n.failed-idoc-row-checkbox:focus-visible + .failed-idoc-checkbox-custom {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.failed-idoc-row-checkbox:checked + .failed-idoc-checkbox-custom {\n  border-color: #667eea;\n  background: #667eea;\n  color: #fff;\n  box-shadow: 0 1px 2px rgba(102, 126, 234, 0.35);\n}\n\n.failed-idoc-checkbox-custom--header {\n  border-style: dashed;\n  border-color: #cbd5e1;\n  background: #fff;\n  cursor: default;\n  pointer-events: none;\n}\n\n.failed-idoc-select-empty {\n  color: #cbd5e1;\n  font-size: 13px;\n}\n\n.failed-idoc-action-th,\n.failed-idoc-action-cell {\n  white-space: nowrap;\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .failed-idoc-page .filter-date-input,\n[data-theme=\"dark\"] .failed-idoc-filter-input,\n[data-theme=\"dark\"] .failed-idoc-reset-btn,\n[data-theme=\"dark\"] .failed-idoc-pagination-btn {\n  background: var(--surface);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .failed-idoc-filters,\n[data-theme=\"dark\"] .failed-idoc-pagination {\n  background: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .failed-idoc-filter-label,\n[data-theme=\"dark\"] .failed-idoc-pagination-info {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .failed-idoc-reset-btn:hover:not(:disabled),\n[data-theme=\"dark\"] .failed-idoc-pagination-btn:hover:not(:disabled),\n[data-theme=\"dark\"] .failed-idoc-sortable-th:hover {\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n}\n[data-theme=\"dark\"] .job-monitor-table .row-failed {\n  background: rgba(220, 38, 38, 0.14);\n}\n[data-theme=\"dark\"] .job-monitor-table .row-failed:hover {\n  background: rgba(220, 38, 38, 0.24);\n}\n[data-theme=\"dark\"] .job-monitor-table .failed-idoc-row-selected {\n  background: rgba(102, 126, 234, 0.18) !important;\n}\n[data-theme=\"dark\"] .failed-idoc-select-th,\n[data-theme=\"dark\"] .failed-idoc-select-cell,\n[data-theme=\"dark\"] .failed-idoc-page .job-monitor-table thead .failed-idoc-select-th {\n  background: var(--surface-2);\n  border-right-color: var(--border);\n}\n[data-theme=\"dark\"] .failed-idoc-checkbox-custom {\n  border-color: var(--border-strong);\n  background: var(--surface);\n}\n[data-theme=\"dark\"] .failed-idoc-checkbox-custom--header {\n  background: var(--surface);\n}\n\n@media (max-width: 768px) {\n  .failed-idoc-page .batch-monitor-header .filter-section {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .failed-idoc-page .filter-date-input {\n    min-width: 0;\n    width: 100%;\n  }\n\n  .failed-idoc-page .filter-section .filter-btn {\n    width: 100%;\n  }\n\n  .failed-idoc-filters {\n    padding: 12px;\n  }\n\n  .failed-idoc-filters-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .failed-idoc-filters-actions {\n    justify-content: stretch;\n  }\n\n  .failed-idoc-reset-btn {\n    width: 100%;\n  }\n\n  .failed-idoc-table-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .failed-idoc-table-toolbar .failed-idoc-pagination {\n    min-width: 0;\n  }\n\n  .failed-idoc-toolbar-actions {\n    justify-content: stretch;\n    flex-wrap: wrap;\n  }\n\n  .failed-idoc-retrigger-btn {\n    width: 100%;\n  }\n\n  .failed-idoc-selection-pill {\n    white-space: normal;\n  }\n\n  .failed-idoc-pagination {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .failed-idoc-pagination-controls {\n    justify-content: center;\n  }\n\n  .failed-idoc-pagination-info {\n    white-space: normal;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
